<template>
  <div>
    <b-card-header :class="`${isDark ? 'dark_bg' : 'bg-white'}`">
      <div class="col-12 d-flex justify-content-between align-items-center ">
        <span class="fs-lg-19 fs-sm-10 fs-md-20"> 滚球大小球进行中比赛（{{ resultData.length }}）场 </span>
        <div class=" d-flex">
          <!-- Item View Radio Button Group  -->
          <b-form-radio-group v-model="itemView" class="ml-1 list item-view-radio-group" buttons size="sm"
            button-variant="outline-primary">
            <b-form-radio v-for="option in itemViewOptions" :key="option.value" :value="option.value">
              <feather-icon :icon="option.icon" size="18" />
            </b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div class="text-center p-4 bg-primary text-light rounded mt-20" v-if="resultData.length==0">
          <!-- <b-icon icon="cloud-upload" font-scale="4" /> -->
          <feather-icon icon="UploadCloudIcon" size="40" class="blinking" />
          <div class="mb-3 mt-20">
            当前暂无正在比赛中的数据，正在云分析中<span class="blinking">...</span>
          </div>
        </div>

    </b-card-header>

    <b-overlay :show="busy" no-wrap >
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded" >
          <!-- <b-icon icon="cloud-upload" font-scale="4" /> -->
          <feather-icon icon="CloudIcon" size="40" class="blinking" />
          <div class="mb-3 mt-20">
            正在云分析中...
          </div>
          <b-progress min="1" max="20" :value="counter" variant="success" height="3px" class="rounded-0" />
        </div>
      </template>
    </b-overlay>

    <div class="row mt-10 " v-if="this.itemView == 'grid-view'">
      <div class="col-lg-4 col-md-6 col-sm-12" v-for="item in resultData" :key="item.matchId" v-if="dataload">
        <MatchCard :matchData="item"></MatchCard>
      </div>
    </div>
    <div class="row mt-10" v-else>
      <div class="col-12">
        <MatchList :resultData="resultData" :matchStatus="'js'" />
      </div>
    </div>


    <div class="card mb-25 border-0 rounded-0 mt-10">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

        <b-card-header>
          <h4>
            已完结比赛（{{ finishResultData.length }}）场次
          </h4>
        </b-card-header>

        <MatchList :resultData="finishResultData" :matchStatus="'ls'" />
      </div>
    </div>

  </div>

</template>

<script>
import MatchList from '../components/MatchList.vue'
import MatchCard from '../components/MatchCard.vue'
import request from '@/utils/request.js';

import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'

import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BOverlay,
  BForm,
  BProgress,
  BIcon,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BFormFile,
} from 'bootstrap-vue'

export default {
  components: {
    MatchList,
    MatchCard,
    BButton,
    BOverlay,
    BForm,
    BProgress,
    BIcon,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BFormFile,
  },

  directives: {
    Ripple,
  },

  data: function () {
    return {
      itemView: 'grid-view',
      resultData: [],
      finishResultData: [],
      itemViewOptions: [
        { icon: 'GridIcon', value: 'grid-view' },
        { icon: 'ListIcon', value: 'list-view' },
      ],
      dataload: false,
      busy: false,
      processing: false,
      counter: 1,
      interval: null,
      timer1:'',
    };
  },

  // created(){
  //     console.log('created');
  // },

  // destroyed(){
  //   console.log('destroyed');
  // },

  created() {
    this.getData();

    this.onOK();

    //每隔三秒，去查询一次状态
    this.timer1 = setInterval(() => {
      this.getData(true);
    }, 30000);
  },

  destroyed() {
    console.log('-----',this.timer1);
    // 清理定时器
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },

  beforeDestroy() {
    this.clearInterval()
  },


  methods: {

    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    onOK() {
      this.counter = 1
      this.processing = true
      this.busy = true;
      this.clearInterval()
      // Simulate an async request
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter += 1
        } else {
          this.$nextTick(() => {
            this.clearInterval()
            // eslint-disable-next-line
            this.busy = this.processing = false
          })
        }
      }, 350)
    },

    async getData() {
      var post_url =
        'football//admin/william/interfaceAction!receiveAutoBetInfo.action?sjlx=007' + '&cxlx=02';
      let opts = {
        type: 1, // 1为数据接口；2为静态资源请求  
        url: post_url,
        method: 'get'
      };

      if (!request.hadToken()) {
        return;
      }

      let res = await request.httpRequest(opts);
      this.resultData = [];
      this.finishResultData = [];
      const resList = res.data.listAutoBetInfo;

      for (let entity of resList) {
        if (entity.nowstatus !== '完') {
          var matchPostUrl =
            'football//admin/william/interfaceAction!getOldsByMathId.action?id=' + entity.matchId;
          let matchOpts = {
            type: 1, // 1为数据接口；2为静态资源请求  
            url: matchPostUrl,
            method: 'get'
          };

          let matchRes = await request.httpRequest(matchOpts);
          const matchModel = matchRes.data.matchModel;
          entity.matchModel = matchModel;
          this.resultData.push(entity);
        } else {
          this.finishResultData.push(entity);
        }
      }
      this.busy = this.processing = false
      this.dataload = true;
    },
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
}
</script>


<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-ecommerce.scss";

[dir] .card-header {
  padding: 1rem 1.5rem;
}

/* 定义一个闪烁动画 */
@keyframes blink {

  /* 从0%开始到100%，‌通过opacity属性在1（‌完全不透明）‌和0（‌完全透明）‌之间交替 */
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

/* 应用闪烁动画到一个类 */
.blinking {
  /* 使用无限次重复闪烁动画 */
  animation: blink 0.5s infinite;
}

.dark_bg {
  background-color: #283046;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
}
</style>
